import {useNavigate} from 'react-router-dom';

export const useMultiStepForm = () => {
  const navigate = useNavigate();

  const fullUrl = window.location.href;
  const currentStepWithParams = fullUrl.split('/').at(-1);
  const currentStep = currentStepWithParams?.split('?')[0];
  const stepNumber = Number(currentStep?.split('-')[1]);

  const goNext = (isDirectLoan: boolean) => {
    if (isNaN(stepNumber)) return;
    navigate(
      `/receive-${isDirectLoan ? 'loan' : 'credit'}/step-${stepNumber + 1}`,
    );
  };

  const goPrev = (isDirectLoan: boolean) => {
    if (isNaN(stepNumber)) return;
    navigate(
      `/receive-${isDirectLoan ? 'loan' : 'credit'}/step-${stepNumber - 1}`,
    );
  };

  return {currentStep, stepNumber, goNext, goPrev};
};
